import * as React from 'react';

import PropTypes from 'prop-types';
import _ from 'underscore';

import styles from './leaderboard-empty-state.module.css';

const EMPTY_ROW_COUNT = 4;

export class LeaderboardEmptyState extends React.Component {
    static propTypes = {
        isError: PropTypes.bool.isRequired,
    };

    render() {
        const emptyText = this.props.isError
            ? "We couldn't load this leaderboard"
            : 'No one was found for this leaderboard';
        const emptyRows = _.range(EMPTY_ROW_COUNT).map((column, index) => {
            return <div key={`empty-row-${index}`} className={styles['empty-row']} />;
        });

        return (
            <div className={styles.container}>
                {emptyRows}
                <div className={styles['empty-image-container']}>
                    <img
                        src='/include/images/dashboard/search-peach-empty_2x.png'
                        className={styles['empty-image']}
                    />
                </div>
                <div className={styles['empty-text']}>
                    <span>{emptyText}</span>
                </div>
            </div>
        );
    }
}
